import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </M>
  );
};

export const SectionHead = ({ eyebrow, title, intro, align = "left", id }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className="mb-5 inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.32em] text-[var(--gold)]">
        {align !== "center" && <span className="h-px w-10 bg-[var(--gold)]" />}
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 id={id} className="font-display text-3xl font-semibold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base leading-relaxed text-[var(--muted)] md:text-lg">{intro}</p>
      </Reveal>
    )}
  </div>
);
